import React from 'react';
import {Button, Flex, Form, Input, Select} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import IntlMessage from "../../../../../../components/IntlMessage/IntlMessage";
import classes from "../../../Applications/application.module.css";

const {TextArea} = Input;

const Step7Disciplines = ({data}) => {
    const {t} = useTranslation();

    const opDisciplines = Form.useWatch('opDisciplines');

    return (
        <Flex style={{width: "100%", position: "relative"}} vertical gap={"small"}>
            <Form.List name="opDisciplines" rules={[{required: true, message: t('requiredField')}]}>
                {(fields, {add, remove}) => (
                    <Flex vertical gap={10}>
                        <IntlMessage id={"microQ.disciplines"}/>
                        {fields.map(({key, name, ...restField}) => {
                            const disciplineCode = opDisciplines?.[name]?.code;
                            return (
                                <Flex
                                    key={key}
                                    gap={"small"}
                                    justify={"flex-start"}
                                    align={"baseline"}
                                    vertical
                                    style={{
                                        padding: 8,
                                        border: '1px solid white',
                                        borderRadius: 8,
                                        backgroundColor: "white"
                                    }}
                                >
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'nameRu']}
                                        className={classes.formInputBlock}
                                        rules={[{required: true, message: t('requiredField')}]}
                                    >
                                        <Input placeholder={t('nameRu')}/>
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'nameKz']}
                                        className={classes.formInputBlock}
                                        rules={[{required: true, message: t('requiredField')}]}
                                    >
                                        <Input placeholder={t('nameKz')}/>
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'nameEng']}
                                        className={classes.formInputBlock}
                                        rules={[{required: true, message: t('requiredField')}]}
                                    >
                                        <Input placeholder={t('nameEng')}/>
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'descriptionRu']}
                                        className={classes.formInputBlock}
                                        rules={[
                                            {required: true, message: t('requiredField')},
                                            {
                                                validator: (_, value) => {
                                                    if (!value) return Promise.resolve();
                                                    const words = value.trim().split(/\s+/).filter(Boolean);
                                                    if (words.length > 50) {
                                                        return Promise.reject(new Error(t('max50Words')));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            },
                                        ]}
                                    >
                                        <TextArea placeholder={t('microQ.disciplineDesc') + " " + t('inRu')}/>
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'descriptionKz']}
                                        className={classes.formInputBlock}
                                        rules={[
                                            {required: true, message: t('requiredField')},
                                            {
                                                validator: (_, value) => {
                                                    if (!value) return Promise.resolve();
                                                    const words = value.trim().split(/\s+/).filter(Boolean);
                                                    if (words.length > 50) {
                                                        return Promise.reject(new Error(t('max50Words')));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            },
                                        ]}
                                    >
                                        <TextArea placeholder={t('microQ.disciplineDesc') + " " + t('inKz')}/>
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'descriptionEng']}
                                        className={classes.formInputBlock}
                                        rules={[
                                            {required: true, message: t('requiredField')},
                                            {
                                                validator: (_, value) => {
                                                    if (!value) return Promise.resolve();
                                                    const words = value.trim().split(/\s+/).filter(Boolean);
                                                    if (words.length > 50) {
                                                        return Promise.reject(new Error(t('max50Words')));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            },
                                        ]}
                                    >
                                        <TextArea placeholder={t('microQ.disciplineDesc') + " " + t('inEng')}/>
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        rules={[{required: true, message: t('requiredField')}]}
                                        label={t('amOpCreditNum')}
                                        className={classes.formInputBlock}
                                        name={[name, "creditNumbers"]}
                                    >
                                        <Input type={'number'} placeholder={t("amOpCreditNum")}/>
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        rules={[{required: true, message: t('requiredField')}]}
                                        label={t('amOpAcademHrsNum')}
                                        className={classes.formInputBlock}
                                        name={[name, "academicHours"]}
                                    >
                                        <Input type={'number'} placeholder={t("amOpAcademHrsNum")}/>
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'code']}
                                        label={t('amOpDisciplineCode')}
                                        className={classes.formInputBlock}
                                        rules={[{required: true, message: t('requiredField')}]}
                                    >
                                        <Input placeholder={t('amOpDisciplineCode')}/>
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'controlForm']}
                                        label={t('microQ.controlForm')}
                                        className={classes.formInputBlock}
                                        rules={[{required: true, message: t('requiredField')}]}
                                    >
                                        <Input placeholder={t('microQ.controlForm')}/>
                                    </Form.Item>
                                    {disciplineCode !== 'FC' && (
                                        <Form.Item
                                            rules={[{required: true, message: t('requiredField')}]}
                                            label={t('microQ.formCompetence')}
                                            labelCol={{span: 24}}
                                            style={{width: '100%', padding: 0}}
                                            name={[name, 'competenceIds']}
                                        >
                                            <Select
                                                mode="multiple"
                                                options={data?.competences?.list?.map(c => ({
                                                    value: c.id,
                                                    label: ("ПК" + c.name.number)
                                                }))}
                                            />
                                        </Form.Item>
                                    )}
                                    <MinusCircleOutlined onClick={() => remove(name)}/>
                                </Flex>
                            )
                        })}
                        <Form.Item>
                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                                <IntlMessage id={"certificate.addField"}/>
                            </Button>
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="dashed"
                                onClick={() =>
                                    add({
                                        nameRu: "Итоговая аттестация",
                                        nameKz: "Қорытынды аттестация",
                                        nameEng: "Final Attestation",
                                        descriptionRu:
                                            "Целью итоговой аттестации обучающегося является оценка результатов обучения и профессиональных компетенций, достигнутых по завершению изучения образовательной программы микроквалификации",
                                        descriptionKz: "Білім алушыны қорытынды аттестаттаудың мақсаты микроквалификацияның білім беру бағдарламасын зерделеу аяқталғаннан кейін қол жеткізілген Оқыту нәтижелері мен кәсіби құзыреттіліктерді бағалау болып табылады",
                                        descriptionEng: "The purpose of the final certification of the student is to evaluate the learning outcomes and professional competencies achieved upon completion of the study of the educational program of microqualification",
                                        creditNumbers: 1,
                                        academicHours: 30,
                                        code: "FC",
                                        controlForm: "Экзамен",
                                    })
                                }
                                block
                                icon={<PlusOutlined/>}
                            >
                                <IntlMessage id={"micro.addFinalAttestation"}/>
                            </Button>
                        </Form.Item>
                    </Flex>
                )}
            </Form.List>
        </Flex>
    );
};

export default Step7Disciplines;
